// extracted by mini-css-extract-plugin
export var featuredWrapper = "Featured-module--featuredWrapper--xe1tU";
export var featured_card = "Featured-module--featured_card--TxNvr";
export var featured_card_hover = "Featured-module--featured_card_hover--NvYsx";
export var featured_container = "Featured-module--featured_container--w1Jjz";
export var featured_heading = "Featured-module--featured_heading--3nP6A";
export var featured_image = "Featured-module--featured_image--d5Sjj";